import { render, staticRenderFns } from "./EditPaper.vue?vue&type=template&id=0f4f2225&scoped=true"
import script from "./EditPaper.vue?vue&type=script&lang=js"
export * from "./EditPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f2225",
  null
  
)

export default component.exports